import { render, staticRenderFns } from "./ListaEmpleado.vue?vue&type=template&id=4634fa8a"
import script from "./ListaEmpleado.vue?vue&type=script&lang=js"
export * from "./ListaEmpleado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports